module.exports = __webpack_public_path__ + "static/media/dev-10.734306e3.png";